import React from 'react';
import Banner from '../components/Banner';
import CoinTable from '../components/CoinTable';

const Home = () => {
  return (
    <>
      <Banner />
      <CoinTable />
    </>
  )
}

export default Home;